import { z } from 'zod'

const TimeWindowSchema = z.object({
  start: z.string(),
  end: z.string()
})

const RewardSpecSchema = z.object({
  type: z.string(),
  subType: z.string(),
  quantity: z.number(),
  options: z.object({
    activationType: z.string().optional(),
    boost: z
      .object({
        unit: z.string(),
        value: z.number()
      })
      .optional()
  })
})

const ReceivedItemSchema = z.object({
  id: z.string(),
  status: z.enum(['claimable', 'claimed', 'applied', 'used', 'expired'])
})

const StreakStepSchema = z.object({
  step: z.number(),
  rewardSpec: RewardSpecSchema,
  receivedItem: ReceivedItemSchema.nullish()
})

export const DailyStreakSchema = z.object({
  type: z.literal('daily_streak'),
  currentStep: z.number(),
  lastLoginAt: z.string().optional(),
  lastBetAt: z.string().optional(),
  nextLoginWindow: TimeWindowSchema.optional(),
  nextBetWindow: TimeWindowSchema.optional(),
  steps: z.array(StreakStepSchema)
})
